import * as React from 'react';
import { useCallback, useContext, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { createNote } from '@/redux/app/actions/ticket';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';
import { UserInfoContext } from '../user/user-info';

export interface NewNoteFormProps {
  ticket: string;
  callId?: string;
}

export const NewNoteForm = React.memo((props: NewNoteFormProps) => {
  const { ticket, callId } = props;
  const subdomain = useContext(NavigationPaneRouteParamsContext)?.subdomain;
  const { name, email } = useContext(UserInfoContext);
  const dispatch = useDispatch();
  const inputRef = useRef<HTMLTextAreaElement>();
  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const note = inputRef.current.value.trim();
    if (note.length > 0) {
      dispatch(createNote({
        subdomain,
        ticket,
        note,
        callId,
        senderTag: name || email,
      }));
    }
    inputRef.current.value = '';
  }, [callId, ticket, subdomain, dispatch, inputRef]);

  return (
    <form
      className={callId ? 'call-notes-form' : 'ticket-notes-form'}
      id={!callId ? 'ticket-notes-form' : null}
      acceptCharset="UTF-8"
      onSubmit={handleSubmit}
    >
      <textarea ref={inputRef} placeholder="Add a note..." className="notes-input" data-role="none" />
      <div className="ui-btn ui-input-btn ui-corner-all ui-shadow">
        Save
        <input
          type="submit"
          name="commit"
          value="Save"
          data-role="none"
        />
      </div>
    </form>
  );
});
